import { render, staticRenderFns } from "./Newbooking.vue?vue&type=template&id=29c5099e&scoped=true&"
import script from "./Newbooking.vue?vue&type=script&lang=js&"
export * from "./Newbooking.vue?vue&type=script&lang=js&"
import style0 from "./Newbooking.vue?vue&type=style&index=0&id=29c5099e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c5099e",
  null
  
)

export default component.exports